import { Injectable } from '@angular/core';
import { select } from '@ngxs/store';
import { TenantUserAccessState } from '../state/tenant-user-access.state';

@Injectable({
  providedIn: 'root',
})
export class TenantUserPrivilegesService {
  private privilegesFlatSig = select(TenantUserAccessState.getPrivilegesFlat);
  private isProductOwnerSig = select(TenantUserAccessState.isProductOwner);

  userHasPrivilege(privilege: string | string[]): boolean {
    if (this.isProductOwnerSig()) {
      return true;
    }
    const privilegesFlat = this.privilegesFlatSig() ?? [];
    if (privilege instanceof Array) {
      return privilege.some((singlePriv: string) => privilegesFlat.includes(singlePriv));
    }
    return privilegesFlat.some((flatPrivilege: string) => flatPrivilege === privilege);
  }

  userHasAllPrivileges(privileges: string[]): boolean {
    if (this.isProductOwnerSig()) {
      return true;
    }

    const privilegesFlat = this.privilegesFlatSig() ?? [];
    return privileges.every((singlePriv: string) => privilegesFlat.includes(singlePriv));
  }

  recursiveFilterMenuItemsPerPrivileges(menuItems: any) {
    const isProductOwner = this.isProductOwnerSig() ?? false;
    const privilegesFlat = this.privilegesFlatSig() ?? [];
    return menuItems.reduce((filtered: any, item: any) => {
      let hasMatchingPrivilege = false;
      if (isProductOwner) {
        hasMatchingPrivilege = true;
      } else if (item.privileges?.length === 0) {
        hasMatchingPrivilege = true;
      } else if (item.checkAllPrivileges) {
        hasMatchingPrivilege = item.privileges?.every((privilege: any) =>
          privilegesFlat.includes(privilege)
        );
      } else {
        hasMatchingPrivilege = item.privileges?.some((privilege: any) =>
          privilegesFlat.includes(privilege)
        );
      }
      const filteredChildren = this.recursiveFilterMenuItemsPerPrivileges(item.children);

      if (hasMatchingPrivilege || filteredChildren.length > 0) {
        filtered.push({ ...item, children: filteredChildren });
      }

      return filtered;
    }, []);
  }
}
